import { Button, Grid } from "@material-ui/core";
import React from "react";
import Modal from "./modal.mesf";

interface Props {
	error: string | null;
	onHide: () => void;
	title?: string;
	size?: "xs" | "sm" | "md" | "lg" | "xl" | false;
}

export const ErrorModal = ({
	error,
	onHide,
	title = "Ups!",
	size = "md",
}: Props) => {
	return !!error ? (
		<Modal
			open={true}
			handleClose={() => {
				onHide();
			}}
			title={title}
			maxWidth={size}
		>
			<Modal.Content>
				<div>{error}</div>
			</Modal.Content>
			<Modal.Actions>
				<Grid
					container
					spacing={2}
					justifyContent="flex-end"
					style={{ padding: "1rem", minWidth: "600px" }}
				>
					<Grid item md={2} xs={12}>
						<Button
							fullWidth
							variant="contained"
							color="default"
							onClick={() => {
								onHide();
							}}
						>
							Ok
						</Button>
					</Grid>
				</Grid>
			</Modal.Actions>
		</Modal>
	) : null;
};
